import React, { createContext, type ReactNode, useContext, useMemo } from 'react';

interface UnifiedAnalyticsConfig {
	crossAppInteractionSessionsEnabled?: boolean;
	productSwitcher?: string;
}

interface UnifiedAnalyticsContextProviderProps {
	children: ReactNode;
	crossAppInteractionSessionsEnabled?: boolean;
	productSwitcher?: string;
}

const UnifiedAnalyticsContext = createContext<UnifiedAnalyticsConfig | undefined>(undefined);

export const UnifiedAnalyticsContextProvider = ({
	crossAppInteractionSessionsEnabled = false,
	productSwitcher = 'appSwitcher',
	children,
}: UnifiedAnalyticsContextProviderProps): React.JSX.Element => {
	const contextValue = useMemo<UnifiedAnalyticsConfig>(
		() => ({
			crossAppInteractionSessionsEnabled,
			productSwitcher,
		}),
		[productSwitcher, crossAppInteractionSessionsEnabled],
	);

	return (
		<UnifiedAnalyticsContext.Provider value={contextValue}>
			{children}
		</UnifiedAnalyticsContext.Provider>
	);
};

export const useUnifiedAnalyticsContext = (): UnifiedAnalyticsConfig => {
	const context = useContext(UnifiedAnalyticsContext);

	return (
		context ?? {
			crossAppInteractionSessionsEnabled: false,
			productSwitcher: 'appSwitcher',
		}
	);
};
